export default `float s=4.;
    p=abs(p);
    vec3 off=p*4.6;
    for (float i=0.; i<8.; i++){
      p=1.-abs(abs(p-2.)-1.);
      float r=-13.*clamp(.38*max(1.3/dot(p,p),.7),0.,3.3);
      s*=r; p*=r; p+=off;
    }
    return length(cross(p,normalize(vec3(1.0,3.0,3.0))))/s-.006;
  }`